import { useCallback } from 'react';
import { NavLink } from 'react-router-dom-v5-compat';
import cx from 'classnames';
import { camelCase } from 'lodash';
import PropTypes from 'prop-types';

import { TruncatedSpan } from 'src/components/TruncatedSpan';

import { SidebarButton } from '../SidebarButton';

import { useStyles } from './useStyles';

const getComponent = (item) => {
  if (item.path) {
    if (item.externalLink) {
      return 'a';
    }

    if (!item.disableNavigation) {
      return NavLink;
    }
  }

  return undefined;
};

const getButtonProps = (item) => {
  if (item.path) {
    if (item.externalLink) {
      return {
        href: item.path,
        target: '_blank',
      };
    }

    if (!item.disableNavigation) {
      return {
        to: item.path,
      };
    }
  }

  return {};
};

export const SidebarLink = ({ className, item, active, onClick, ...restProps }) => {
  const styles = useStyles();
  const component = getComponent(item);

  const handleClick = useCallback(() => {
    onClick(item);
  }, [item, onClick]);

  return (
    <SidebarButton
      className={cx(styles.root, className)}
      item={item}
      active={active}
      component={component}
      onClick={handleClick}
      data-testid={`SidebarLink_${camelCase(item.label)}`}
      {...getButtonProps(item)}
      {...restProps}
    >
      <TruncatedSpan>{item.label}</TruncatedSpan>
    </SidebarButton>
  );
};

SidebarLink.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape().isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

SidebarLink.defaultProps = {
  className: '',
  active: false,
};
